import { device } from '@src/common/breakpoints';
import { BodyRegularSemiBold, BodySmall } from '@src/fonts/typography/Typography';
import styled from 'styled-components';

interface YearViewSingleMonthDayProps {
  isVisible: boolean;
}

export const YearlyViewMonthName = styled.p`
  ${BodySmall}

  text-align: right;
  ${device.smallTablet} {
    ${BodyRegularSemiBold}
  }
`;
export const YearlyViewMonthArea = styled.div`
  background-color: transparent;
  display: flex;
  gap: 1vh 1vw;
  flex-direction: column;
  align-items: flex-end;
  cursor: pointer;
  transition: background-color 0.2s ease-out;
  &:hover {
    background-color: #eeeeee;
  }
  border-radius: 4px;
  padding: 8px;
  ${device.smallTablet} {
    padding: 12px 16px 16px 16px;
  }
`;

export const YearlyViewMonthAreaInner = styled.div`
  margin: auto;
`;

export const YearViewSingleMonth = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 6px);
  grid-template-rows: repeat(6, 6px);
  justify-items: end;
  align-items: end;
  gap: 0.1vh 0.1vw;
  ${device.mobile} {
    gap: 0.3vh 0.3vw;
    grid-template-columns: repeat(7, 8.8px);
    grid-template-rows: repeat(6, 8.8px);
  }
`;

export const YearViewSingleMonthDay = styled.div<YearViewSingleMonthDayProps>`
  width: 6px;
  height: 6px;
  border-radius: 2px;
  background-color: ${({ isVisible }) => (isVisible ? '#c4c4c4' : 'transparent')};
  ${device.mobile} {
    width: 8.8px;
    height: 8.8px;
  }
`;

export const Container = styled.div`
  display: grid;
  flex-wrap: wrap;
  column-gap: 1vw;
  row-gap: 1vh;
  justify-content: space-between;
  align-items: start;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-columns: minmax(0, 1fr);
  ${device.mobile} {
    grid-template-columns: repeat(4, 1fr);
  }
`;
